import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Motion";
import Testimonials from "@/components/Testimonials";
import FAQ, { FAQ_ITEMS } from "@/components/FAQ";
import Seo, { faqSchema } from "@/components/Seo";

export default function FAQPage() {
  return (
    <div data-testid="faq-page">
      <Seo
        title="FAQ — Common Questions Before Enrolling"
        description="Answers to the questions students ask before enrolling at Secrecy Executive Training Academy — permits, eligibility, firearms, payment plans, and our verified-graduate testimonial policy."
        path="/faq"
        schema={faqSchema(FAQ_ITEMS)}
      />

      <section className="border-b border-white/10 pt-24 pb-12">
        <div className="container-x">
          <div className="overline mb-4">// FILE 004 — FAQ</div>
          <h1 className="font-heading text-5xl md:text-7xl tracking-tighter leading-[0.9] max-w-4xl">
            Things people ask <span className="text-[#FFD300]">before enrolling.</span>
          </h1>
        </div>
      </section>

      <section className="section-pad" data-testid="faq-section">
        <div className="container-x grid grid-cols-12 gap-12">
          <div className="col-span-12 lg:col-span-4">
            <Reveal>
              <div className="overline mb-4">// 001 — COMMON QUESTIONS</div>
              <h2 className="font-heading text-3xl md:text-4xl tracking-tighter leading-tight mb-6">Straight answers.</h2>
              <p className="text-neutral-400 leading-relaxed mb-6">Have a different question? Our operations team responds personally.</p>
              <Link to="/contact" className="btn-secondary inline-flex" data-testid="faq-contact-cta">Contact ops <ArrowRight size={14} /></Link>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-8">
            <Reveal delay={0.15}>
              <FAQ />
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-[#050505] border-y border-white/10 section-pad" data-testid="testimonials-section">
        <div className="container-x grid grid-cols-12 gap-12 items-center">
          <div className="col-span-12 lg:col-span-5">
            <Reveal>
              <div className="overline mb-4">// 002 — INTEGRITY</div>
              <h2 className="font-heading text-4xl md:text-6xl tracking-tighter leading-[0.95] mb-6">
                Real graduates.<br/><span className="text-[#FFD300]">Real quotes only.</span>
              </h2>
              <p className="text-neutral-400 leading-relaxed text-lg">
                We launched in 2024 and won't publish a single testimonial until a real, verified
                graduate wants to say something on the record. Meanwhile — meet the instructors.
              </p>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <Reveal delay={0.2}>
              <Testimonials />
            </Reveal>
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-x flex flex-wrap items-center justify-between gap-6">
          <div>
            <div className="overline mb-3">// NEXT STEP</div>
            <h3 className="font-heading text-3xl md:text-4xl tracking-tighter">Already took a class? See what to file next.</h3>
          </div>
          <Link to="/resources" className="btn-primary inline-flex" data-testid="faq-resources-cta">After-Class Resources <ArrowRight size={14} /></Link>
        </div>
      </section>
    </div>
  );
}
